/**
 * Configuração da instância Axios para comunicação com a API.
 *
 * Este módulo configura uma instância do Axios para realizar requisições HTTP
 * para a API do backend, utilizando a URL base definida nas variáveis de ambiente.
 * Também fornece uma função para configurar o token de autenticação.
 *
 * @module api
 */

import axios from 'axios';

/**
 * Instância do Axios configurada com a URL base da API.
 *
 * Esta instância é utilizada para todas as requisições HTTP ao backend,
 * garantindo consistência na configuração e facilitando a manutenção.
 *
 * @type {import('axios').AxiosInstance}
 */
const api = axios.create({
  baseURL: process.env.REACT_APP_ENDPOINT_API,
});

/**
 * Configura o token de autenticação para as requisições.
 *
 * Esta função define o cabeçalho de autorização para todas as requisições
 * subsequentes feitas através da instância do Axios. Se nenhum token for
 * fornecido, o cabeçalho de autorização será definido como null.
 *
 * @function setToken
 * @param {string|null} idToken - Token de acesso JWT ou null para remover o token
 */
export function setToken(idToken) {
  const token = !idToken ? null : `Bearer ${idToken}`;
  api.defaults.headers['Authorization'] = token;
}

export default api;
